.embed {
  background-color: var(--background-color-primary, background-color('primary'));
  border: 1px solid var(--border-color-primary, border-color('primary'));
  border-radius: var(--radius-m, $radius-m);
  inset: 0;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  min-height: pxToRem(400);
  max-height: 100%;
  overflow: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  @media (--md-min) {
    background-color: var(--background-color-secondary, background-color('secondary'));

    orama-input {
      padding: 0;
      margin: 0;
      border-radius: 0;
    }

    input[type='search'] {
      border-radius: var(--radius-m, $radius-m) var(--radius-m, $radius-m) 0 0;
    }
  }
}
